// Convert img to svg
const convertToSVG = (): void => {
  const imgElements = document.querySelectorAll('img.svg')

  imgElements.forEach(imgElement => {
    const querySelectorImg = imgElement as HTMLElement
    const imgID = querySelectorImg.getAttribute('id')
    const imgClass = querySelectorImg.getAttribute('class')
    const imgURL = querySelectorImg.getAttribute('src')

    if (imgURL) {
      fetch(imgURL)
        .then(response => response.text())
        .then(data => {
          // Get the SVG tag, ignore the rest
          const querySelectorSvg = document.createRange().createContextualFragment(data).querySelector('svg')

          // Add replaced image's ID to the new SVG
          if (imgID !== null) {
            querySelectorSvg?.setAttribute('id', imgID)
          }

          // Add replaced image's classes to the new SVG
          if (imgClass !== null) {
            querySelectorSvg?.setAttribute('class', `${imgClass} replaced-svg`)
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          querySelectorSvg?.removeAttribute('xmlns:a')

          // Check if the viewport is set, if the viewport is not set, the SVG won't scale.
          if (
            !querySelectorSvg?.getAttribute('viewBox') &&
            querySelectorSvg?.getAttribute('height') &&
            querySelectorSvg?.getAttribute('width')
          ) {
            querySelectorSvg.setAttribute(
              'viewBox',
              `0 0 ${querySelectorSvg.getAttribute('height')} ${querySelectorSvg.getAttribute('width')}`
            )
          }

          // Replace image with new SVG
          if (querySelectorSvg) {
            querySelectorImg.replaceWith(querySelectorSvg)
          }
        })
        .catch(error => {
          console.error('Error fetching SVG:', error)
        })
    }
  })
}

document.addEventListener('DOMContentLoaded', convertToSVG)
